import { flow, SnapshotIn, types } from "mobx-state-tree";
import {
  FilterValue,
  filterValueToUpdate,
  parseFilterValue
} from "./FilterValue";
import { OrderFilters } from "./OrderFilters";
import { PreferenceBase } from "./PreferenceBase";

export const OrderFiltersPreference = types
  .compose(
    "OrderFiltersPreference",
    PreferenceBase,
    types.model("_OrderFiltersPreference", {
      value: types.maybe(OrderFilters)
    })
  )
  .actions(self => ({
    /**
     * Returns the value that should be sent to the server representing this preferences update. This method does not update the preference with the new value.
     * @param key The database pkey this preference represents.
     * @param value The new value of the preference.
     * @returns The value representing this update to be sent to the server.
     */
    valueForUpdate(
      key: string,
      value: {
        signed: number;
        offices: SnapshotIn<typeof FilterValue>;
        statuses: SnapshotIn<typeof FilterValue>;
        providers: SnapshotIn<typeof FilterValue>;
        types: SnapshotIn<typeof FilterValue>;
      }
    ) {
      return {
        offices: filterValueToUpdate(value.offices),
        statuses: filterValueToUpdate(value.statuses),
        providers: filterValueToUpdate(value.providers),
        types: filterValueToUpdate(value.types),
        signed: value.signed
      };
    },
    /**
     * Applies a loaded preference value from the database to this preference object. If the value needs to have some work done to it before storing it (e.g. fetching models from IDs) that happens in this method.
     * @param value The new value from the server.
     */
    // disable lint to keep the interface the same
    // eslint-disable-next-line require-yield
    applyLoadedPrefValue: flow(function*(value) {
      self.value = OrderFilters.create({
        offices: parseFilterValue(value.offices),
        statuses: parseFilterValue(value.statuses),
        providers: parseFilterValue(value.providers),
        types: parseFilterValue(value.types),
        signed: value.signed
      });
    })
  }));
